import React, { useState } from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/site/Seo";
import {
  LayoutDashboard, BookOpen, Bookmark, XCircle, TrendingUp, ShoppingBag,
  Bell, User, LogOut, Menu, X,
} from "lucide-react";

const LINKS = [
  { to: "/student/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/student/test-series", label: "My Test Series", icon: BookOpen, id: "test-series" },
  { to: "/student/performance", label: "Performance", icon: TrendingUp, id: "performance" },
  { to: "/student/bookmarks", label: "Bookmarks", icon: Bookmark, id: "bookmarks" },
  { to: "/student/wrong-questions", label: "Wrong Questions", icon: XCircle, id: "wrong" },
  { to: "/student/orders", label: "Orders", icon: ShoppingBag, id: "orders" },
  { to: "/student/notifications", label: "Notifications", icon: Bell, id: "notifications" },
  { to: "/student/profile", label: "Profile", icon: User, id: "profile" },
];

export default function StudentLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const Side = () => (
    <div className="flex flex-col h-full">
      <Link to="/" className="px-5 py-5"><Logo className="h-8" /></Link>
      <nav className="flex-1 px-3 space-y-1 overflow-y-auto">
        {LINKS.map((l) => (
          <NavLink key={l.id} to={l.to} onClick={() => setOpen(false)} data-testid={`student-nav-${l.id}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-ember-soft text-ember" : "text-content-secondary hover:bg-card-hover hover:text-content"}`}>
            <l.icon className="w-4 h-4" /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-line">
        <button onClick={() => { logout(); nav("/"); }} data-testid="student-logout"
          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-content-secondary hover:text-red-400 w-full">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-ink flex">
      <aside className="hidden lg:block w-64 border-r border-line bg-surface fixed inset-y-0"><Side /></aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-surface border-r border-line"><Side /></div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden glass-nav border-b border-line px-4 h-14 flex items-center justify-between sticky top-0 z-40">
          <button onClick={() => setOpen(true)}><Menu className="w-5 h-5" /></button>
          <Logo className="h-7" />
          <span className="text-sm text-content-secondary">{user?.name?.split(" ")[0]}</span>
        </header>
        <main className="container-px py-8"><Outlet /></main>
      </div>
    </div>
  );
}
